module.exports = __webpack_public_path__ + "img/PRCA2_Plasma.2431dc80.png";